








import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import AngleSelector from './AngleSelector.vue';

@Component({
  components: {
    AngleSelector,
  },
})
export default class LossOfVerticalityConfig extends Vue {
  @Prop()
  public value: any;

  @Watch('value', { immediate: true })
  public onValChange(): void {
      if (!this.value) {
          this.$emit('input', {});
      }
  }
}
